export default __webpack_public_path__ + "static/media/big-question.5765d054.svg";